import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function Pricing() {
  return <section className="bg-[#FFFEF7] py-6 md:py-12 lg:py-[60px]" id="pricing" data-id="element-121">
      <div className="container mx-auto px-4" data-id="element-122">
        <div className="max-w-4xl mx-auto bg-white rounded-[24px] shadow-[0_10px_50px_rgba(0,0,0,0.1)] overflow-hidden border-2 border-[#FFD700]" data-id="element-123">
          <div className="bg-[#1B3A6B] py-4 md:py-5 text-center text-white" data-id="element-124">
            <h2 className="font-poppins font-bold text-[20px]" data-id="element-125">
              OFERTA DE LANZAMIENTO
            </h2>
          </div>

          <div className="p-6 md:p-8 lg:p-10 text-center" data-id="element-126">
            <h3 className="text-[#1B3A6B] font-poppins font-black md:text-5xl mb-3 text-[20px]" data-id="element-127">
              CÓDIGO DE EMERGENCIA ESCOLAR™
            </h3>
            <p className="text-[#FF6B35] font-poppins font-bold text-xl mb-5 md:mb-6" data-id="element-128">
              NIVEL PRIMARIO · PACK COMPLETO
            </p>

            <div className="flex flex-col items-center mb-6 md:mb-8" data-id="element-129">
              <span className="text-[#555555] line-through text-xl mb-1" data-id="element-130">
                $27.990
              </span>
              <div className="flex items-baseline gap-2" data-id="element-131">
                <span className="text-[#1B3A6B] font-poppins font-black md:text-8xl text-[48px]" data-id="element-132">
                  $19.990
                </span>
                <span className="text-[#1B3A6B] font-bold" data-id="element-133">ARS</span>
              </div>
              <p className="text-[#555555] mt-2 md:mt-3 font-medium" data-id="element-134">
                Pago único · Acceso de por vida
              </p>
            </div>

            <div className="md:space-y-3 mb-6 md:mb-8 max-w-md mx-auto text-left space-y-[-4px]" data-id="element-135">
              <div className="flex items-center gap-3" data-id="element-136">
                <span className="text-[#2D9B6F]" data-id="element-137">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-138">
                  4 Módulos de formación y acción
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-139">
                <span className="text-[#2D9B6F]" data-id="element-140">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-141">
                  3 Bonos exclusivos de regalo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-142">
                <span className="text-[#2D9B6F]" data-id="element-143">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-144">
                  260+ páginas de material listo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-145">
                <span className="text-[#2D9B6F]" data-id="element-146">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-147">
                  Acceso inmediato por email
                </span>
              </div>
            </div>

            {/* Secure Payment Block */}
            <div className="mb-5 md:mb-6" data-id="element-148">
              <p className="text-[#555555] text-[13px] md:text-sm font-medium mb-3" data-id="element-149">
                Pagarás de forma 100% segura mediante:
              </p>
              <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mb-4" data-id="element-150">
                <img src="https://logodownload.org/wp-content/uploads/2019/06/mercado-pago-logo.png" alt="Mercado Pago" className="h-6 md:h-7 object-contain" loading="lazy" data-id="element-151" />
                
                
                
              </div>

              {/* Trust Block — Instant Digital Delivery */}
              <div className="bg-[#F0FDF4] border border-[#BBF7D0] rounded-xl px-4 py-3 max-w-lg mx-auto" data-id="element-152">
                <p className="text-[#15803D] text-[13px] font-medium leading-snug" data-id="element-153">
                  📦{' '}
                  <span className="font-bold" data-id="element-154">
                    ENTREGA DIGITAL INSTANTÁNEA:
                  </span>{' '}
                  Sin costos de envío. Recibís el acceso en tu email al
                  instante.
                </p>
              </div>
            </div>

            <CTAButton success href="https://checkout.guiadigital360.online/cart/45019141144645:1" className="w-full max-w-lg mx-auto mb-3" data-id="element-155">
              → ACCEDER AHORA
            </CTAButton>

            <p className="text-[#555555] text-[12px] md:text-[13px] mb-5 md:mb-6" data-id="element-156">
              Serás redirigido a la pasarela segura de Mercado Pago.
            </p>

            {/* Purchase Backing Row */}
            <div className="grid grid-cols-3 gap-3 md:gap-4 max-w-xl mx-auto pt-4 border-t border-[#E5E5E5]" data-id="element-157">
              <div className="flex flex-col items-center gap-1.5" data-id="element-158">
                <span className="text-2xl md:text-3xl" aria-hidden="true" data-id="element-159">
                  🛡️
                </span>
                <p className="text-[#2C2C2C] text-[11px] md:text-xs font-semibold leading-tight" data-id="element-160">
                  Compra Protegida por Mercado Pago
                </p>
              </div>
              <div className="flex flex-col items-center gap-1.5" data-id="element-161">
                <span className="text-2xl md:text-3xl" aria-hidden="true" data-id="element-162">
                  ⚡
                </span>
                <p className="text-[#2C2C2C] text-[11px] md:text-xs font-semibold leading-tight" data-id="element-163">
                  Acceso Inmediato (Formato PDF)
                </p>
              </div>
              <div className="flex flex-col items-center gap-1.5" data-id="element-164">
                <span className="text-2xl md:text-3xl" aria-hidden="true" data-id="element-165">
                  🏅
                </span>
                <p className="text-[#2C2C2C] text-[11px] md:text-xs font-semibold leading-tight" data-id="element-166">
                  7 Días de Garantía de Satisfacción
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 md:mt-8 text-center" data-id="element-167">
          <p className="text-[#555555] mb-3" data-id="element-168">
            ¿Tenés dudas o preferís transferencia?
          </p>
          <CTAButton isWhatsApp href="https://wa.me/5492966244076?text=Hola%2C%20vengo%20de%20la%20p%C3%A1gina%20de%20C%C3%B3digo%20de%20Emergencia%20Escolar%20Nivel%20Primario%20y%20quiero%20finalizar%20mi%20compra%20del%20pack%20completo.%20%F0%9F%9A%A8" className="mx-auto" data-id="element-169">
            HABLAR POR WHATSAPP
          </CTAButton>
        </div>
      </div>
    </section>;
}